// components/RemarkDialog.tsx
import { AxiosResponse } from 'axios';
import Cookies from 'js-cookie';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { EligibilityResponse } from 'src/app/interfaces/ApiResponse';
import { confirmRedemption } from 'src/app/services/EndUserService';
import { redeemOffer } from 'src/app/services/PlanService';

interface DialogProps {
  visible: boolean;
  onClose: () => void;
  header: string;
  cardNumber: string | null;
  data: EligibilityResponse | null;
}

const SuccessDialog: React.FC<DialogProps> = ({ visible, onClose, header, cardNumber, data }) => {
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleHide = () => {
    onClose();
  };


  const handleRedeem = async () => {
    setLoading(true);

    try {
      const redemptionId = String(data?.data.redemption_id);
      const response = await confirmRedemption(redemptionId);

      if (response?.status === 200) {
        navigate('/redeem/offer?redemption_id=' + data?.data?.redemption_id);
      }

    } catch (error: any) {
      if (error.response) {
        const { status, data: errData } = error.response;

        if (status === 422) {
          toast.current?.show({
            severity: 'error',
            summary: 'Validation Error',
            detail: errData.message || 'Redemption failed. Please try again.',
            life: 3000,
          });
        } else if (status === 500) {
          toast.current?.show({
            severity: 'error',
            summary: 'Server Error',
            detail: 'Something went wrong. Please try again later.',
            life: 3000,
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: 'Error',
            detail: errData?.message || 'Unexpected error occurred.',
            life: 3000,
          });
        }
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'Network Error',
          detail: 'Check your connection and try again.',
          life: 3000,
        });
      }
    }

    setLoading(false);
  };


  return (
    <>
      <Toast ref={toast} />
      <Dialog
        style={{ width: '35vw' }}
        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
        visible={visible}
        onHide={handleHide}
        // header={header}
        dismissableMask
        closable={false}
      >
        <div className="w-full py-2 ">
          <div className="grid">
            <div className="col-12 lg:col-12 px-2">
              <div className="text-center">
                <i
                  className="pi  pi-check-circle text-center"
                  style={{ color: '#22C55E', fontSize: '2.5rem' }}
                ></i>
              </div>

              <h3 className="mb-3 text-center font-bold">{t('landing.esim_eligibility.congratulations_title')}</h3>

              <p className="mb-5 text-center">
                {t('landing.esim_eligibility.eligibility_message')}
              </p>

              <p className="mb-5 text-center">
                {t('landing.esim_eligibility.instruction_message')}

              </p>

              <div className="flex flex-row gap-2">
                <Button
                  className="w-full"
                  label={t('landing.esim_eligibility.not_now_button')} severity="secondary" outlined
                  onClick={() => handleHide()}
                />

                {/* <Button
                  className="w-full align-items-center"
                  onClick={() => handleRedeem()}
                  disabled={loading}
                  style={{ zIndex: 1000 }}
                >
                  {loading && <i className="pi pi-spinner pi-spin text-sm"></i>}
                  <span className="font-medium">  {t('landing.esim_eligibility.redeem_now_button')}</span>
                </Button> */}

                <Button
                  className="w-full justify-content-center"
                  label={!loading ? t('landing.esim_eligibility.redeem_now_button') : undefined}
                  icon={loading ? 'pi pi-spinner pi-spin' : undefined}
                  iconPos="left"
                  onClick={() => handleRedeem()}
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default SuccessDialog;
